(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function renderTier(root, totalCents) {
    if (!root) return;
    var t1 = parseInt(root.getAttribute('data-tier-1-threshold'), 10) || 0;
    var t2 = parseInt(root.getAttribute('data-tier-2-threshold'), 10) || 0;
    var l1 = root.getAttribute('data-tier-1-label') || 'Free Shipping';
    var l2 = root.getAttribute('data-tier-2-label') || '20% Discount';

    root.setAttribute('data-cart-total', String(totalCents));

    var t1Hit = totalCents >= t1;
    var t2Hit = totalCents >= t2;
    var pct;
    var msg;

    function escape(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    var l2Esc = escape(l2);
    if (t2Hit) {
      pct = 100;
      msg = 'You have unlocked <strong>' + l2Esc + '</strong> on your entire order';
    } else if (t1Hit) {
      var span = t2 - t1;
      var consumed = totalCents - t1;
      pct = span > 0 ? Math.round((consumed * 100) / span) : 100;
      msg =
        '<strong>Free Shipping</strong> Applied Add ' +
        escape(formatMoney(t2 - totalCents)) +
        ' for <strong>' +
        l2Esc +
        '</strong>';
    } else {
      pct = t1 > 0 ? Math.round((totalCents * 100) / t1) : 0;
      msg =
        'You are ' +
        escape(formatMoney(t1 - totalCents)) +
        ' away from <strong>FREE SHIPPING</strong>!';
    }

    var msgEl = root.querySelector('[data-cart-tier-message]');
    if (msgEl) msgEl.innerHTML = msg;

    var fill = root.querySelector('[data-cart-tier-fill]');
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('is-complete', t2Hit);
    }

    var m1 = root.querySelector('[data-cart-tier-milestone="1"]');
    if (m1) m1.classList.toggle('is-hit', t1Hit);
    var m2 = root.querySelector('[data-cart-tier-milestone="2"]');
    if (m2) m2.classList.toggle('is-hit', t2Hit);
  }

  function findRoot() {
    return document.querySelector('[data-cart-tier]');
  }

  // Tiers are measured against the pre-discount total so the tier discount
  // itself doesn't push the cart back below the threshold.
  function tierTotal(cart) {
    if (typeof cart.original_total_price === 'number') return cart.original_total_price;
    return cart.total_price || cart.totalPrice || 0;
  }

  function updateFromCart(cart) {
    var root = findRoot();
    if (!root) return;
    renderTier(root, tierTotal(cart));
  }

  function fetchCartAndUpdate() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateFromCart(cart);
        maybeApplyTier2Code(cart);
      })
      .catch(function () {});
  }

  function maybeApplyTier2Code(cart) {
    var host = document.querySelector('cart-drawer');
    if (!host) return;
    var code = host.getAttribute('data-tier-2-code');
    if (!code) return;
    var t2 = parseInt(host.getAttribute('data-tier-2-threshold'), 10) || 0;
    if (tierTotal(cart) < t2) return;
    var existing = (cart.cart_level_discount_applications || [])
      .concat(cart.discount_codes || [])
      .map(function (d) { return (d.code || d.title || '').toLowerCase(); });
    if (existing.indexOf(code.toLowerCase()) !== -1) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code })
    }).catch(function () {});
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCartAndUpdate();
  });

  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) {
      updateFromCart(e.detail.cart);
      maybeApplyTier2Code(e.detail.cart);
    } else {
      fetchCartAndUpdate();
    }
  });
})();
